"use client";

import { useEffect } from "react";
import { useMediaAuth } from "@/hooks/useMediaAuth";
import { isMp3OnlyMode } from "@/lib/mp3OnlyMode";
import { useStore } from "@/store";

/**
 * Runs the initial auth-session check once at app boot so route-level screens
 * can read a hydrated auth store immediately.
 */
export default function AuthBootstrap() {
  const { checkSession } = useMediaAuth();

  useEffect(() => {
    if (isMp3OnlyMode) {
      useStore.setState({
        user: null,
        authStatus: "unauth",
        error: null,
      });
      return;
    }

    void checkSession();
  }, [checkSession]);

  return null;
}
